import React, { Children } from 'react';
import { FormField } from "admin-on-rest";
export const renderItemFormPlanType = (children, record, resource, basePath) =>{
  return(
    Children.map(
      children,
      input =>
        input &&
        (input.props.source === "plan_type" ) && (
          <div
            key={input.props.source}
            className={`aor-input-${input.props.source}`}
            style={input.props.style}
          >
            <FormField
              input={input}
              resource={resource}
              record={record}
              basePath={basePath}
            />
          </div>
        )
    )
  )
};


// WEBPACK FOOTER //
// ./src/products/edit/PlanTypeField.js